import React from "react";

function Navbar() {
  return (
    <div className="h-[60px] bg-white my-4 rounded-md flex justify-center items-center gap-2 text-xl font-medium">
      <img src="/firebaseLogo.svg" />
      <h1 className=" ">Firebase Contact App</h1>
    </div>
  );
}

export default Navbar;
